import { useEffect, useState } from 'react';
import { IPatientUser } from '../../../../../providers/auth/types';
import { useAuth } from '../../../../../providers/auth';
import { storagePrefix } from '../../../../../utils/storage';

const useLoginPopUp = () => {
  const { setPatientData } = useAuth();

  const receiveMessage = (event: any) => {
    if (event.data.value === "loginMsg") {
      const response = JSON.parse(event.data.message);

      const { token, userName, userId } = response.data;
      const patientUser: IPatientUser = { userName, userId };
      localStorage.setItem(`${storagePrefix}token`, JSON.stringify(token));
      localStorage.setItem(
        `${storagePrefix}patientUser`,
        JSON.stringify(patientUser)
      );

      setPatientData({ token, patientUser });
    }
  };

  const openLoginPopUp = () => {
    window.addEventListener("message", receiveMessage, false);

    window.open(
      "https://login.conectadoc.com.br/", // TODO: adicionar URL definitiva login.conectadoc.com.br/...
      "Popup",
      `width=500,height=630, left=${(window.innerWidth - 500) / 2}, top=${(window.innerHeight - 630) / 2
      }`
    );
  };

  return { openLoginPopUp };
};

export default useLoginPopUp